import { render, staticRenderFns } from "./ServiceWork.vue?vue&type=template&id=14d7a324&scoped=true"
import script from "./ServiceWork.vue?vue&type=script&lang=js"
export * from "./ServiceWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d7a324",
  null
  
)

export default component.exports